import script from "./EquipmentTypeLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./EquipmentTypeLegend.vue?vue&type=script&setup=true&lang=js"

import "./EquipmentTypeLegend.vue?vue&type=style&index=0&id=6a38e5c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a38e5c1"]])

export default __exports__